let productObj = {};

// These run inside configureEvents' listener loops alongside the Instant
// Proof mount and other page logic. A throw here used to end that loop, so
// every listener registered after this one was skipped for that event. Read
// the DOM defensively: a page can legitimately have no price yet (first quote
// failed or was superseded) and no continue button.
if (window.configureEvents) {
    var setValues = {
        onCalcLoaded: function(product) {
            window.tbg.product.value = getProdPrice();
            window.tbg.product.qty = getProdQty();
            setProductValues();
            pushViewItemEvent();
            console.log('Product events');
            const continueButton = document.querySelector('.quoteContinue > button');
            if (continueButton) {
                continueButton.addEventListener('click', pushAddToCartEvent);
            }
        },
        onQuoteUpdated: function(product) {
            window.tbg.product.value = getProdPrice();
            window.tbg.product.qty = getProdQty();
            setProductValues();
        }
    }
    configureEvents.registerOnCalcLoadedListener(setValues);
    configureEvents.registerOnQuoteUpdatedListener(setValues);
}

function setProductValues () {
    productObj = {
        currency: "USD",
        value: window.tbg.product.value,
        items: [
            {
            item_id: window.tbg.product.id,
            item_name: window.tbg.product.name,
            affiliation: "Smartpress",
            currency: "USD",
            price: window.tbg.product.value,
            quantity: window.tbg.product.qty
            }
        ]
    };
}

function getProdPrice (priceElement = document.querySelector('.lineItemPrice')) {
    if (!priceElement) {
        return null;
    }
    return Number(parseFloat(priceElement.innerText.slice(1).replace(/,/g, '')));
}

function getProdQty () {
    return document.getElementsByName('QUANTITYEF')[0] ? parseInt(document.getElementsByName('QUANTITYEF')[0].value) : 0;
}

function pushViewItemEvent () {
    gtag("event", "view_item", productObj);
}

function pushAddToCartEvent () {
    gtag("event", "add_to_cart", productObj);
}